<template lang="pug">
	.element-properties-add(v-show="showed" :style="position" v-pseudo-modal-name="'element-properties-add'")
		MultiLevelDropdownMenu(ref="dropdownMenu" @change="addProperty($event.item, $event.data)")
</template>

<script>
	import Screen from './../../mixins/screen'

	import MultiLevelDropdownMenu from './../UI/MultiLevelDropdownMenu'

	export default {
		name: 'EditorElementInfoPropertiesAdd',
		mixins: [Screen],
		screen: {
			updateOn: [],
			events: {
				"Show EditorElementInfoPropertiesAdd": function(el, element, currentSizeElementProps) {

					this.element = element;
					this.currentSizeElementProps = currentSizeElementProps;

					let rect = el.getBoundingClientRect();

					this.position.right = (document.body.clientWidth - rect.right) + 'px';
					this.position.bottom = (document.body.clientHeight - rect.bottom) + 'px';

					this.update();

				},
				// Клик в любом месте кроме контента помеченного element-properties-add - закрывает компонент
				"Pseudo Modal Process Hide": function(names) {

					if (!_.includes(names, 'element-properties-add') && this.showed) {

						this.close();

					}

				}
			}
		},
		components: {
			MultiLevelDropdownMenu
		},
		props: [],
		data() {
			return {
				position: {
					right: 0,
					bottom: 0
				}
			};
		},
		methods: {
			collectData() {

				if (!this.element) return;

				let dataItem = {title: 'Data', width: 200, opened: false, childs: _.map([{title: "Number", description: "Number variable"}, {title: "String", description: "String variable"}], property => {
					return {..._.pick(property, ['title', 'description']), width: 200, disabled: true, data: {dataCodename: property.codename}}
				})};

				if (this.element.type === 'global') {

					let eventItemsTree = [
						dataItem
					];

					if (this.$refs.dropdownMenu) this.$refs.dropdownMenu.setItems(eventItemsTree);

				} else {

					let props = _.filter(_.orderBy(Metadata.ElementProperties, 'priority'), propertyParams => propertyParams.active && (!propertyParams.options.elementTypes || _.includes(propertyParams.options.elementTypes, this.element?.type)));

					let mainItem = {
						title: 'Main', width: 200, opened: false, childs: _.map(_.filter(props, o => o.section === 'main'), property => {
								return {..._.pick(property, ['title', 'description']), width: 200, disabled: property.codename in this.currentSizeElementProps || property.options["displayAlways"], data: {propertyCodename: property.codename}}
							}
						)
					};

					let dimensionItem = {
						title: 'Dimensions', width: 200, opened: false, childs: _.map(_.filter(props, o => o.section === 'dimensions'), property => {
								return {..._.pick(property, ['title', 'description']), width: 200, disabled: property.codename in this.currentSizeElementProps || property.options["displayAlways"], data: {propertyCodename: property.codename}}
							}
						)
					};

					let filtersItem = {
						title: 'Filters', width: 200, opened: false, childs: _.map(_.filter(props, o => o.section === 'filters'), property => {
								return {..._.pick(property, ['title', 'description']), width: 200, disabled: property.codename in this.currentSizeElementProps || property.options["displayAlways"], data: {propertyCodename: property.codename}}
							}
						)
					};

					let maskItem = {
						title: 'Mask', width: 200, opened: false, childs: _.map(_.filter(props, o => o.section === 'mask'), property => {
								return {..._.pick(property, ['title', 'description']), width: 200, disabled: property.codename in this.currentSizeElementProps || property.options["displayAlways"], data: {propertyCodename: property.codename}}
							}
						)
					};

					let behaviorItem = {
						title: 'Behavior', width: 200, opened: false, childs: _.map(_.filter(props, o => o.section === 'behavior'), property => {
								return {..._.pick(property, ['title', 'description']), width: 200, disabled: property.codename in this.currentSizeElementProps || property.options["displayAlways"], data: {propertyCodename: property.codename}}
							}
						)
					};

					let eventItemsTree = [
						mainItem,
						dimensionItem,
						filtersItem,
						maskItem,
						behaviorItem,
						dataItem
					];

					if (this.$refs.dropdownMenu) this.$refs.dropdownMenu.setItems(eventItemsTree);

				}

			},
			addProperty(item, data) {

				console.log('addProperty', data.propertyCodename);

				Server.sendToSocket({
					AddElementProperty: {
						elementId: this.element.id,
						elementPropertyCodename: data.propertyCodename,
						sizeKey: Layout.getPreviewSizeKey()
					}
				});

				this.close();

			},
			close() {

				if (this.$refs.dropdownMenu) this.$refs.dropdownMenu.close();

				this.hide();

			}
		}
	}
</script>

<style lang="sass">

	.element-properties-add
		position: absolute
		margin-top: 1px
		user-select: none

</style>
